import { useState, useEffect, useMemo } from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Divider,
  InputAdornment,
  InputBase,
} from '@mui/material';
import { useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import { getAllISOFromDialCode } from 'utils/function';
import { phoneLength } from './phoneLength';

const CustomPhoneInput = ({ value, onChange, onFetchComplete, error, helperText, width }) => {
  const [phoneNumber, setPhoneNumber] = useState(value || '');
  const [isLoading, setIsLoading] = useState(false);

  const vendorCountry = useSelector((state) => state?.posData?.country_code);
  const country_ISO = getAllISOFromDialCode(vendorCountry);
  const autofetchmobilenumbercount = useSelector((state) => state?.posData?.autofetchmobilenumbercount ?? 10);

  // ✔ Dynamic max length based on country
  const maxLength = useMemo(() => {
    if (!country_ISO) return phoneLength["GB"]; 
    return phoneLength[country_ISO] ?? phoneLength["GB"];
  }, [country_ISO]);

  const digitsOnly = (val) => {
    if (typeof val !== "string") return ""; // ensure replace never fails
    return val.replace(/\D/g, "");
  };

  // Sync internal state when the value prop changes externally (e.g., parent resets it to "")
  useEffect(() => {
    const digits = digitsOnly(value || '');
    if (digits !== phoneNumber) {
      setPhoneNumber(digits);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);


   const handleChange = (e) => {
    let digits = digitsOnly(e.target.value);

    // enforce per-country max
    if (digits.length > maxLength) {
      digits = digits.slice(0, maxLength);
    }

    if (digits !== phoneNumber) {
      setPhoneNumber(digits);
      onChange?.(digits);
    }
  };

  // ✔ Trim existing value when country changes
  useEffect(() => {
    const current = digitsOnly(phoneNumber);
    if (current.length > maxLength) {
      const trimmed = current.slice(0, maxLength);
      setPhoneNumber(trimmed);
      onChange?.(trimmed);
    }
  }, [vendorCountry, maxLength]);

  // const handleChange = (e) => {
  //   const digits = e.target.value.replace(/\D/g, '');
  //   if (digits.length <= autofetchmobilenumbercount) {
  //     setPhoneNumber(digits);
  //     onChange?.(digits);
  //   }
  // };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          border: error ? '1px solid #d32f2f' : '1px solid #A1A1A1',
          borderRadius: 2,
          width: width ? width : 350,
        }}
      >
        <Box sx={{ px: 1.2, display: 'flex', alignItems: 'center' }}>
          <Typography className='d-flex align-items-center'>
             <AddIcon fontSize={"10px"}/>
            {vendorCountry}
            </Typography>
        </Box>
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            height: '30px',
            borderRightWidth: '1.5px',    // ← thicker border
            borderColor: '#A1A1A1',
            mt: 0.7,
          }}
        />

        <InputBase
          placeholder="Mobile Number"
          value={phoneNumber}
          onChange={handleChange}
          //   endAdornment={
          //     isLoading && (
          //       <InputAdornment position="end">
          //         <CircularProgress size="1rem" />
          //       </InputAdornment>
          //     )
          //   }
          sx={{
            pl: 1,
            pr: 1,
            height: 40,
            flex: 1,
            fontSize: '0.875rem',
          }}
          inputProps={{
            maxLength: 12,
            sx:{
              padding:'0px'
            }
          }}
        />
      </Box>
      {helperText && (
        <Typography variant="caption" color={error ? 'error' : 'textSecondary'} sx={{ mt: 0.5 }}>
          {helperText}
        </Typography>
      )}
    </>
  );
};

export default CustomPhoneInput;